import React, { useState, useEffect, useRef } from 'react';
import styles from './assets/index.module.css';
import { LeftOutlined, RightOutlined, StarFilled } from '@ant-design/icons';
import chosenImg from './assets/img/chosen.png';
import payWay from './assets/img/pay-way.png';
import iconCar from './assets/img/icon-car.png';
import iconZan from './assets/img/icon-zan.png';
import iconGuard from './assets/img/icon-guard.png';
import iconSetting from './assets/img/icon-setting.png';
import avatar1 from './assets/img/avatar1.jpg';
import avatar2 from './assets/img/avatar2.jpg';
import avatar3 from './assets/img/avatar3.jpg';
import avatar4 from './assets/img/avatar4.jpg';
import avatar5 from './assets/img/avatar5.jpg';
import avatar6 from './assets/img/avatar6.jpg';
import avatar7 from './assets/img/avatar7.jpg';
import avatar8 from './assets/img/avatar8.jpg';

import { Carousel } from 'antd';
import { query_product_recommend_list } from '../../services/api.js';
import { useLocation } from 'react-router-dom';
// 热门推荐模拟接口数据
const appList = [];

// 客户评价固定数据
const testimonials = [
  {
    id: 1,
    avatar: avatar1,
    name: '某个人用户',
    date: '2023-04-10',
    content: '我的国内手机号接收不到验证码，于是在别的网站上购买了一个直接使用，账号质量非常好，手机端直接就登录进去了，客户小姐姐服务也很好，会教一些电报的使用技巧。'
  },
  {
    id: 2,
    avatar: avatar2,
    name: '某外贸个体户',
    date: '2023-07-15',
    content: '我们做了很久的推广市场，这在这个平台买过一些社账号推广使用。不得不说，账号质量和服务质量真的很好，为我们这些打工人省了不少时间！'
  },
  {
    id: 3,
    avatar: avatar3,
    name: '某大学学生',
    date: '2024-06-09',
    content: '软件激活非常麻烦，直接在他们家购买的软件和激活码，非常给力，质量非常好。'
  },
  {
    id: 4,
    avatar: avatar4,
    name: '某玩家用户',
    date: '2024-07-13',
    content: '激活码充值很快，比官方便宜太多几乎不会被封号，而且换货政策也相当好。'
  },
  {
    id: 5,
    avatar: avatar5,
    name: '某游戏玩家',
    date: '2024-08-14',
    content: '激活码充值很快，比官方便宜太多几乎不会被封号，而且换货政策也相当好。'
  },
  {
    id: 6,
    avatar: avatar6,
    name: '某批发商',
    date: '2025-02-10',
    content: '我们需要大量的激活码和账号，他们家的价格非常优惠，添加他们的微信客服后，他们给到了我一个非常低的价格，从此我们进行的长期的合作。非常赞！'
  },
  {
    id: 7,
    avatar: avatar7,
    name: '某个人用户',
    date: '2025-03-10',
    content: '非常棒的买号体验，我们自己注册的经常被封禁。于是在这个平台上买了几个老号，非常稳定，所有账号都是真实且活跃的使用体验非常好。'
  },
  {
    id: 8,
    avatar: avatar8,
    name: '某玩家',
    date: '2025-08-16',
    content: '刚开始还是抱着试试看的态度，少量购买了一些激活码，没想到激活使用都 ok，远远超过我们的预期，非常好的一个平台。'
  }
];

// 底部服务数据
const serviceList = [
  { icon: iconCar, text: '交货极速', subText: '发货时间快，省心无忧' },
  { icon: iconZan, text: '百万用户', subText: '服务累计百万玩家，靠谱' },
  { icon: iconGuard, text: '支付快捷', subText: '官方聚合付款，稳定持久' },
  { icon: iconSetting, text: '7*12小时在线服务', subText: '即时响应 售后无忧' }
];

const HomePage = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const appsPerPage = 16; // UI中热门推荐每页显示14个
  const [recommend, setRecommend] = useState(appList);
  const carouselRef = useRef(null);
  const locations = useLocation();
  const queryParams = new URLSearchParams(locations.search);
  const code = queryParams.get('code'); // 'key'是你要获取的查询参数的名称

  // 计算总页数和按钮状态
  const totalPages = Math.ceil(recommend.length / appsPerPage);
  // 判断是否有上一页
  const hasPrevPage = currentPage > 0;
  // 判断是否有下一页
  const hasNextPage = currentPage < totalPages - 1;
  // 只有一页时隐藏所有按钮
  const showPagination = totalPages > 1;

  useEffect(() => {
    document.title = '软件激活码购买|软件高速下载|各类虚拟商品购买-624资源网';
    async function fetchData() {
      try {
        const res = await query_product_recommend_list(code);
        const comData = res.data.records.map((item, index) => {
          if (index === 0) {
            item.tag = 'HOT';
          }
          if (index === 1) {
            item.tag = 'NEW';
          }
          if (index === 2) {
            item.tag = '热门';
          }
          return item;
        });
        setRecommend(comData);
        // 重置到第一页
        setCurrentPage(0);
      } catch (error) {
        console.error('获取推荐列表失败:', error);
      }
    }
    fetchData();
  }, []);

  // 切换上一页
  const handlePrev = () => {
    if (hasPrevPage) {
      setCurrentPage(prev => prev - 1);
      scrollCarousel();
    }
  };

  // 切换下一页
  const handleNext = () => {
    if (hasNextPage) {
      setCurrentPage(prev => prev + 1);
      scrollCarousel();
    }
  };

  // 轮播平滑滚动
  const scrollCarousel = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  // 当前页显示的应用
  const currentApps = recommend.slice(currentPage * appsPerPage, (currentPage + 1) * appsPerPage);
  const skipNewHome = code => {
    window.location.href = `/${code}?from=index`;
  };
  return (
    <div className={styles.pageContainer}>
      {/* 头部 */}
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <div className={styles.logo}></div>
          <button className={styles.consultBtn} onClick={() => window.open('https://dl.jujjxiazai.com/order/')}></button>
        </div>
      </header>

      <main className={styles.mainContent}>
        {/* 热门推荐 */}
        <section className={styles.popularSection}>
          <div className={styles.sectionTitle}>热门推荐</div>
          <div className={styles.carouselWrap}>
            <img className={styles.chosen} src={chosenImg} alt={'精选'} />

            {/* 左切换按钮 - 只有有上一页且需要分页时显示/可用 */}
            {showPagination && (
              <button className={`${styles.carouselBtn} ${styles.prevBtn} ${!hasPrevPage ? styles.disabledBtn : ''}`} onClick={handlePrev} disabled={!hasPrevPage}>
                <LeftOutlined />
              </button>
            )}

            {/* 应用列表（轮播容器） */}
            <div ref={carouselRef} className={styles.appsGrid}>
              {currentApps.length > 0 ? (
                currentApps.map((app, index) => (
                  <div key={app.id || index} className={styles.appCard} onClick={() => skipNewHome(app.code)}>
                    {app.tag && <span className={`${styles.appTag} ${styles['tag-' + app.tag.toLowerCase()]}`}>{app.tag}</span>}
                    <img src={app.iconUrl} alt={app.name} className={styles.appIcon} />
                    <p className={styles.appName}>{app.name}</p>
                  </div>
                ))
              ) : (
                <div className={styles.noData}>暂无推荐应用</div>
              )}
            </div>

            {/* 右切换按钮 - 只有有下一页且需要分页时显示/可用 */}
            {showPagination && (
              <button className={`${styles.carouselBtn} ${styles.nextBtn} ${!hasNextPage ? styles.disabledBtn : ''}`} onClick={handleNext} disabled={!hasNextPage}>
                <RightOutlined />
              </button>
            )}
          </div>
        </section>

        {/* 客户评价 */}
        <section className={styles.testimonialSection}>
          <div className={styles.testBox}>
            <div className={styles.sectionTitle}>我们的客户怎么说</div>
            <Carousel autoplay autoplaySpeed={60000} className={styles.container}>
              {[testimonials.slice(0, 4), testimonials.slice(4, 8)].map((item, index) => (
                <div className={styles.testimonialGrid} key={index}>
                  {item.map(item => (
                    <div key={item.id} className={styles.testimonialCard}>
                      <div className={styles.testimonialHeader}>
                        <img src={item.avatar} alt={item.name} className={styles.userAvatar} />
                        <span className={styles.userName}>{item.name}</span>
                        <div className={styles.starRating}>
                          {[1, 2, 3, 4, 5].map(star => (
                            <StarFilled style={{ fontSize: '16px', color: '#FA9424' }} key={star} className={styles.starIcon} />
                          ))}
                        </div>
                      </div>
                      <p className={styles.testimonialContent}>{item.content}</p>
                      <p className={styles.testimonialDate}>{item.date}</p>
                    </div>
                  ))}
                </div>
              ))}
            </Carousel>
          </div>
        </section>

        {/* 支付方式 */}
        <section className={styles.paymentSection}>
          <img className={styles.payWay} src={payWay} alt='' />
        </section>

        {/* 底部服务 */}
        <section className={styles.bg}>
          <div className={styles.serviceSection}>
            <div className={styles.serviceGrid}>
              {serviceList.map((item, idx) => (
                <div key={idx} className={styles.serviceItem}>
                  <img src={item.icon} alt='' className={styles.serviceIcon} />
                  <div className={styles.serviceText}>
                    <div className={styles.mainText}>{item.text}</div>
                    <div className={styles.serviceSubText}>{item.subText}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className={`${styles.group_20} flex-col`}>
          <div className={`${styles.paragraph_1_t}`}>
            <span className={`${styles.paddingl5}`}>Copyright©2023</span>
            <span className={`${styles.paddingl5}`}>jujjxiazai.com</span>
            <span className={`${styles.paddingl5}`}>All rights reserved.</span>
          </div>
          <div className={`${styles.paragraph_1_b}`}>
            <span className={`${styles.paddingl5}`}>杭州巨极下载科技有限公司</span>
            <span className={`${styles.paddingl5}`}>投诉建议：+86 -198 1844 4998 (工作日：09:00-22:00)</span>
            <span className={`${styles.paddingl5} ${styles.gonganicon}`}>浙公网安备 33011002017281号</span>
            <span className={`${styles.paddingl5}`}>浙ICP备2026044439号</span>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HomePage;
